// Raw DB statuses: 
export const TEST = 'test';
export const BLACKLIST = 'black_list';
export const WAIT_MONEY_TRANSFER = 'wait_money_transfer';
export const WAIT_PAYMENT_CONFIRM = 'wait_payment_confirm';
export const WAIT_CHARGE_BACK = 'wait_charge_back';
export const WAIT_REFUND = 'wait_refund';
export const WAIT_REFUND_CONFIRMATION = 'wait_refund_confirmation';
export const CANCELLED = 'cancelled';
export const ADDRESS_VERIFY = 'address_verify';
export const ADDRESS_VERIFY_UPS = 'address_verify_ups';
export const ADDRESS_VERIFY_DHL = 'address_verify_dhl';
export const WAIT_PRESCRIPTION = 'wait_prescription';
export const WAIT_CUSTOMER_ADDITIONAL_ACTIONS = 'wait_customer_additional_actions';
export const ID_VERIFICATION_IN_PROGRESS = 'id_verification_in_progress';
export const WAIT_PRESCRIPTION_GENERATION = 'wait_prescription_generation';
export const PAUSED_FOR_STOCK_VERIFICATION_SWISS = 'paused_for_stock_verification_swiss';
export const WAIT_VIDEO_CONSULTATION = 'wait_video_consultation';
export const WAIT_CUSTOMER_BOOKING_SELECTION = 'wait_customer_booking_selection';
export const WAIT_REPEAT_PRESCRIPTION = 'wait_repeat_prescription';
export const NEED_CUSTOMER_ANSWER = 'need_customer_answer';
export const DOCTOR_REQUESTED_CLARIFICATION = 'doctor_requested_clarification';
export const CLARIFIED_BY_SUPPORT = 'clarified_by_support';
export const READY_TO_SIGN = 'ready_to_sign';
export const WAIT_SIGN_CONFIRMATION = 'wait_sign_confirmation';
export const PROCESSING_WAIT_SIGN_CONFIRMATION = 'processing_wait_sign_confirmation';
export const PRESCRIPTION_REJECTED = 'prescription_rejected';
export const SENT_TO_PHARMACY = 'sent_to_pharmacy';
export const REJECTED_BY_PHARMACY = 'rejected_by_pharmacy';
export const RETURNED_TO_PHARMACY = 'returned_to_pharmacy';
export const SENT_TO_CUSTOMER = 'sent_to_customer';
export const DELIVERED = 'delivered';
export const PHARMACY_INTERNAL_ERROR = 'pharmacy_internal_error';
export const DELIVERY_ISSUES = 'delivery_issues'
export const WAIT_CUSTOMER_PHARMACY_SELECTION = 'wait_customer_pharmacy_selection';
export const FORWARDED_REQUEST_TO_EXTERNAL_PHARMACY = 'forwarded_request_to_external_pharmacy';
export const WAIT_CUSTOMER_DELIVERY_SELECTION = 'wait_customer_delivery_selection';
export const COMPLETED = 'completed';
export const PHARMACY_PENDING_STOCK = 'pharmacy_pending_stock';
export const CANCELLED_BY_CUSTOMER = 'cancelled_by_customer';
export const PRESCRIPTION_REJECTED_BY_PHARMACY = 'prescription_rejected_by_pharmacy';
export const WAIT_CUSTOMER_ALTERNATIVE_SELECTION = 'wait_customer_alternative_selection';
export const WAIT_ALTERNATIVE_PRODUCT_CUSTOMER_DECISION = 'wait_alternative_product_customer_decision';
export const WAIT_CUSTOMER_DECISION = 'wait_customer_decision';
export const WAIT_AUTOMATIC_STOCK_ALLOCATION = 'wait_automatic_stock_allocation';
export const ALTERNATIVE_TREATMENT_OFFERED = 'alternative_treatment_offered';
/** ISO country code of Switzerland (same value as funnel-common LOCALES.countries.Switzerland; the client cannot import funnel-common). */
export const SWITZERLAND = 'CH';

export const dailingCodes= {
  'DE': '+49',
  'CH': '+41',
  'FR': '+33',
  'GB': '+44'
}

// Tooltip identifiers for click tracking
export const TOOLTIP_MEDICATION = 'medication';
export const TOOLTIP_SERVICE_FEE = 'service_fee';
export const TOOLTIP_TREATMENT_FEE = 'treatment_fee';
export const TOOLTIP_SHIPPING_FEE = 'shipping_fee';
export const TOOLTIP_DOCTOR = 'doctor';
export const TOOLTIP_PHARMACY = 'pharmacy';

// User interaction tracking
export const CLICK_EXPAND_PRODUCTS = 'expand_products';
export const CLICK_PARTNER_PHARMACIES_POPUP = 'partner_pharmacies_popup';
export const CLICK_TERMS_LINK = 'terms_link';
export const CLICK_PHARMACY_DETAILS_EXPAND = 'pharmacy_details_expand';



export const ORDER_FLOWS : Record<string,string> = {
  CANNALEO_PRE_SELECTED: "cannaleo_pre_selected",
  FLOWZZ_PRE_SELECTED : "flowzz_pre_selected",
  ONE_PRICE: "one-price",
  MULTIPLE_PRODUCTS: "multiple_products",
  OTC_ONLY: "otc_only",
  STOCK : "stock",
  SCHENGEN: "schengen",
}
export const PRODUCT_TYPES : Record<string,string> = {
  FREE_DRUG: "free_drug",
  TEST_KIT: "test_kit",
  CANNABIS_ID: "cannabis_id",
  PRESCRIPTION_DRUG: "prescription_drug",
  PHARMACY_ONLY_MEDICINE: "pharmacy_only_medicine",
}

export const OTC_PRODUCT_TYPES = [PRODUCT_TYPES.FREE_DRUG, PRODUCT_TYPES.TEST_KIT];
export const DRUGS_PRODUCT_TYPES = [PRODUCT_TYPES.PRESCRIPTION_DRUG, PRODUCT_TYPES.PHARMACY_ONLY_MEDICINE];

// Allowed keys for catalogs.settings.displayed_price_components (displayed medication number only).
export const DISPLAYED_PRICE_COMPONENT_KEYS = [
  'official_price',
  'service_fee',
  'shipping_fee',
  'treatment_fee',
] as const;

export type DisplayedPriceComponent = typeof DISPLAYED_PRICE_COMPONENT_KEYS[number];


//Raw -> formatted
export const FORMATTED_STATUSES : Record<string, string> = {
  [TEST]: "Test",
  [BLACKLIST]: "Blacklist",
  [WAIT_MONEY_TRANSFER]: 'Waiting for money entry',
  [WAIT_PAYMENT_CONFIRM]: 'Waiting for payment confirmation',
  [WAIT_CHARGE_BACK]: 'Waiting for charge back operation',
  [WAIT_REFUND]: 'Refund request is pending.',
  [WAIT_REFUND_CONFIRMATION]: 'Refund request is in progress',
  [CANCELLED]: 'Order cancelled',
  [ADDRESS_VERIFY]: 'Support has questions',
  [ADDRESS_VERIFY_UPS]: 'Waiting for Cash on Delivery confirmation (UPS)',
  [ADDRESS_VERIFY_DHL]: 'Waiting for Cash on Delivery confirmation (DHL)',
  [WAIT_PRESCRIPTION]: 'Physician is checking questionnaire',
  [WAIT_PRESCRIPTION_GENERATION]: 'Physician is checking questionnaire',
  [PAUSED_FOR_STOCK_VERIFICATION_SWISS]: 'Verifying stock for Swiss shipment',
  [WAIT_REPEAT_PRESCRIPTION]: 'Waiting for repeat prescription',
  [NEED_CUSTOMER_ANSWER]: 'Physician has a question',
  [DOCTOR_REQUESTED_CLARIFICATION]: 'Doctor requested clarification',
  [CLARIFIED_BY_SUPPORT]: 'Physician is checking questionnaire (clarified by support)',
  [READY_TO_SIGN]: 'The prescription is ready to be signed',
  [WAIT_SIGN_CONFIRMATION]: 'Waiting for e-sign confirmation',
  [PRESCRIPTION_REJECTED]: 'Prescription rejected',
  [SENT_TO_PHARMACY]: 'Forwarded to pharmacy',
  [REJECTED_BY_PHARMACY]: 'Rejected by pharmacy',
  [PHARMACY_PENDING_STOCK]: 'Pharmacy pending stock',
  [CANCELLED_BY_CUSTOMER]: 'Customer cancelled with the pharmacy',
  [PRESCRIPTION_REJECTED_BY_PHARMACY]: 'Prescription rejected by pharmacy',
  [RETURNED_TO_PHARMACY]: 'Returned to Pharmacy',
  [SENT_TO_CUSTOMER]: 'Order has been sent to customer',
  [DELIVERED]: 'Order delivered',
  [PHARMACY_INTERNAL_ERROR] : 'Pharmacy internal error',
  [DELIVERY_ISSUES]: 'Delivery Issues',
  [WAIT_CUSTOMER_PHARMACY_SELECTION]: 'Pending pharmacy selection by customer',
  [FORWARDED_REQUEST_TO_EXTERNAL_PHARMACY]: 'Forwarded e-recipe to external pharmacy',
  [WAIT_CUSTOMER_DELIVERY_SELECTION]: 'pending customer delivery selection',
  [COMPLETED]: 'Order completed',
  [WAIT_CUSTOMER_DECISION]: 'Pending customer decision',
};


//Event codes:
export const QUESTIONNAIRE_PAGE_VIEW_EVENT = "questionnaire_pv";
export const CHOOSE_TREATMENT_PAGE_VIEW_EVENT = "choose_treatment_pv";
export const START_CONSULTATION_PAGE_VIEW_EVENT = "start_consultation_pv";
export const SHIPPING_PAGE_VIEW_EVENT = "shipping_pv";
export const PAYMENT_PAGE_VIEW_EVENT = "payment_pv";
export const THANKYOU_PAGE_VIEW_EVENT = "View Thank You Page";
export const SIGN_UP_PAGE_VIEW_EVENT = "sign_up_pv";
export const CHOOSE_DOCTOR_PAGE_VIEW_EVENT = "choose_doctor_pv";
export const REGISTRATION_COMPLETED_EVENT = "registration_completed_event";
export const EMAIL_MISMATCH_ERROR_EVENT = "email_mismatch_error";
export const REGISTRATION_INVALID_EMAIL_EVENT = "Registration invalid email";
export const PAID_ORDER_EVENT = "paid_order_event"

export const CANNALEO = "cannaleo"
export const FLOWZZ = "flowzz"
export const CANNALEO_PRE_SELECTED = "cannaleo_pre_selected"
export const FLOWZZ_PRE_SELECTED = "flowzz_pre_selected"
export const EXTERNAL_PHARMACY_INTEGRATIONS_FLOWS = [CANNALEO_PRE_SELECTED, FLOWZZ_PRE_SELECTED]

//Shipping companies
export const DHL = "dhl"
export const UBER = "uber"
export const URBIFY = "urbify"
export const EXPRESS_DELIVERY_COMPANIES = [UBER, URBIFY] as const

// products types
export const PRESCRIPTION_DRUG = "prescription_drug"
export const CANNABIS_ID = "cannabis_id"

export const FLOWZZ_PREMIUM = "flowzz_premium"
/** HL-12814: `fda=1` on the Flowzz landing link pre-selects the Fast Doctor Approval toggle on Choose Treatment (arm B only). */
export const FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM = "fda"
export const FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM_ON = "1"
/** HL-12814: Kameleoon A/B "Flowzz | Fast Doctor Approval | A/B" — Mixpanel property / cart experiment key and its arms. */
export const FLOWZZ_FAST_DOCTOR_APPROVAL_TEST_NAME = "fast_doctor_approval_flowzz_test"
export const FLOWZZ_FAST_DOCTOR_APPROVAL_VARIANTS = ["a", "b"] as const

// Time constants
export const ONE_HOUR_MS = 1000 * 60 * 60; // 1 hour
export const TWENTY_FOUR_HOURS_MS = 1000 * 60 * 60 * 24; // 24 hours
export const FIFTEEN_MINUTES_MS = ONE_HOUR_MS / 4; // 15 minutes

export const DEFAULT_MONTHLY_CANNABIS_PURCHASED_QUANTITY_LIMIT = 200;
export const CANNABIS_LIMIT_ERROR_CODES = ["monthly_limit_exceeded", "cannabis_limit_exceeded"] as const;

// Timezones
export const TIMEZONES = {
  'DE': 'Europe/Berlin',
  'CH': 'Europe/Zurich',
  'FR': 'Europe/Paris',
}

export const SERVICE_OPTIONS = {
  REGULAR: "regular",
  EXPRESS: "express",
  SELF_PICKUP: "self_pickup",
  ONLY_PRESCRIPTION: "only_prescription",
}

// HL-11003 — withhold the catalog auto-discount for returning customers.
// The arm is rolled and stored client-side (localStorage key `abtest_auto_catalog_coupon`),
// then posted to the API, which reconciles the cart. Lowercase: the values go straight into Mixpanel.
export const ABTEST_AUTO_CATALOG_COUPON_NAME = "auto_catalog_coupon";
export const ABTEST_AUTO_CATALOG_COUPON_VARIANT = { CONTROL: "a", TEST: "b" } as const;
export type AbtestAutoCatalogCouponVariant = typeof ABTEST_AUTO_CATALOG_COUPON_VARIANT[keyof typeof ABTEST_AUTO_CATALOG_COUPON_VARIANT];
export const ABTEST_AUTO_CATALOG_COUPON_VARIANTS: readonly AbtestAutoCatalogCouponVariant[] = [ABTEST_AUTO_CATALOG_COUPON_VARIANT.CONTROL, ABTEST_AUTO_CATALOG_COUPON_VARIANT.TEST];
// Participating catalogs are a DB setting (catalogs.settings.auto_catalog_coupon_ab_test_enabled); the
// shipping GET reports it as abtestAutoCatalogCouponEnabled.

// HL-9738 — cannabis service fee A/B test (DE only).
export const SERVICE_FEE_TEST_NAME = "service_fee_test";

// The order's shipping method closed on the payment page — server status and the Shipping page's ?ec= flag
export const SHIPPING_METHOD_UNAVAILABLE = "shipping_method_unavailable";
export const SEARCH_PARAM_FOR_SHIPPING_METHOD_UNAVAILABLE = "smu";
export const SERVICE_FEE_TEST_VARIANT = { CONTROL: "A", TEST: "B", C: "C" } as const;
export type ServiceFeeTestVariant = typeof SERVICE_FEE_TEST_VARIANT[keyof typeof SERVICE_FEE_TEST_VARIANT];
export const SERVICE_FEE_VARIANTS: readonly ServiceFeeTestVariant[] = [SERVICE_FEE_TEST_VARIANT.CONTROL, SERVICE_FEE_TEST_VARIANT.TEST, SERVICE_FEE_TEST_VARIANT.C];

export const CANNABIS_SERVICE_FEE_TEST = {
  FLOWER_FEE_BY_COUNT: { 1: 5.9, 2: 6.9, 3: 7.9 } as Record<number, number>,
  FLOWER_FEE_BY_COUNT_C: { 1: 5.9, 2: 8.9, 3: 10.9 } as Record<number, number>,
  NON_FLOWER_FEE: 9.9,
  MAX_FLOWERS: 3,
} as const;

export const SEARCH_EVENT_DEBOUNCE_MS = 750;
export const MAX_SEARCH_EVENT_COUNT = 150;